import React from "react";
import "./Testimonial.css";
import { FaUserCircle } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const dataTestimonial = [
    {
        id: 1,
        avatar: <FaUserCircle />,
        name: "Intan Anggrayni",
        occupation: "Student at Bunda Mulia University",
        review: "Udah dua kali order jasa web, jujur hasil tugasnya bagus banget... makasii udah membantu aku menyelesaikan tugasnya. Next bisa order lagi 🙏🏻",
    },
    {
        id: 2,
        avatar: <FaUserCircle />,
        name: "Kimberly Huang",
        occupation: "Student at Bunda Mulia University",
        review: "Harga jokinya terjangkau dan hasilnya memuaskan jugaa, 2x pke jasa joki disini gk akan ngecewain.",
    },
    {
        id: 3,
        avatar: <FaUserCircle />,
        name: "Michelle",
        occupation: "Student at Bunda Mulia University",
        review: "Joki disini worth it banget sih, hasilnya keren tp harganya aman banget. Pengerjaan cepet, kakaknya juga fast respon. Selain itu juga bertanggung jawab, pkonya bakal dibantu juga biar file nya siap kirim. Thank you",
    },
    {
        id: 4,
        avatar: <FaUserCircle />,
        name: "Angelica Laurentsia",
        occupation: "Student at Bunda Mulia University",
        review: "Websitenya bagus banget, desainnya juga ga kaku..kalau revisi” juga selalu di respon + pengerjaannya cepet 👌🏻",
    },
    {
        id: 5,
        avatar: <FaUserCircle />,
        name: "Noudricha",
        occupation: "Student at Bunda Mulia University",
        review: "Joki web terbaik sejauh ini, hasilnya ga main main, harga nya juga ramah banget di kantong pelajar. Kalau kalian butuh joki, langsung aja di contact udah trusted kok!!",
    },
    {
        id: 6,
        avatar: <FaUserCircle />,
        name: "Priska",
        occupation: "Student at Bunda Mulia University",
        review: "Joki disini bisa mepet dan hasilnya tetep memuaskan banget.. jgn ragu² deh kalo mau joki disini",
    },
    {
        id: 7,
        avatar: <FaUserCircle />,
        name: "Sari Narulita",
        occupation: "Student at Bunda Mulia University",
        review: "Jawabannya sesuai dengan yg di soal mudah dimengerti juga waktu gmeet dosen bilang dapat A",
    },
    {
        id: 8,
        avatar: <FaUserCircle />,
        name: "Felicia Natalia",
        occupation: "Student at Bunda Mulia University",
        review: "Selalu puas dengan hasil kerjanya. Jika ada yang kurang bisa langsung di perbaiki, Kualitas oke harga pun pas dikantong. Terima kasih.",
    }
];

export default function Testimonial() {
    return (
        <>
            <section id="testimonials">
                <div id="testimonial-container">
                    <div className="testimonial-headline">
                        <p> Review From Client </p>
                        <h1> Testimonials </h1>
                    </div>
                    
                    <div className="testimonial-content">
                        <Swiper
                            pagination={{
                                clickable: true,
                            }}
                            navigation={true}
                            modules={[Navigation, Pagination]}
                        >
                            {dataTestimonial.map(
                                ({ avatar, name, occupation, review}, index) => {
                                    return (
                                        <SwiperSlide
                                            key={index}
                                            >
                                            <div className="testimonial-box">
                                                <div className="testimonial-avatar">
                                                    <span> {avatar} </span>
                                                </div>

                                                <div className="testimonial-biodata">
                                                    <h1> {name} </h1>
                                                    <h5> {occupation} </h5>
                                                </div>

                                                <div className="testimonial-text">
                                                    <p> {review} </p>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                }
                            )}
                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    );
}
